export const EMPTY_IMAGE_PLACEHOLDER_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};
